<template>
  <VRow data-testid="base-save-button-row">
    <VCol cols="12" class="bottom-bar" :style="{ width: bottomBarWidth }">
      <SocioBtn
        :prepend-icon="buttonIcon"
        :text="buttonText"
        :variant="socioStyle === 'secondary' ? 'outlined' : undefined"
        :loading="loading"
        data-testid="save-button"
        @click="emit('action')"
      />
    </VCol>
  </VRow>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useSupervisionStore } from "@/store/modules/supervision";

const emit = defineEmits(["action"]);
defineProps({
  buttonText: {
    type: String,
    default: "save",
  },
  buttonIcon: {
    type: String,
    default: "mdi-content-save",
  },
  socioStyle: {
    type: String,
    default: "primary",
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const route = useRoute();
const supervisionStore = useSupervisionStore();

const isInMission = computed(() => {
  return !!route.params.missionId;
});

const hasActiveSupervisionPanel = computed(() => {
  return supervisionStore.showSupervisionPanelManually;
});

const bottomBarWidth = computed(() => {
  if (isInMission.value && hasActiveSupervisionPanel.value) {
    return "calc(100% - 434px)";
  }
  return "100%";
});
</script>

<style lang="scss" scoped>
.bottom-bar {
  position: fixed;
  bottom: 0px;
  background-color: #eceef3;
  left: 0;
  border-top: 1px solid #d4d5de;
  border-left: 1px solid #d4d5de;
  border-bottom: 1px solid #d4d5de;
  z-index: 5;
  margin-bottom: -2px;
  display: flex;
  justify-content: flex-end;

  @media (max-width: 768px) {
    width: 100% !important;
  }
}
</style>
<i18n>
{
    "en": {
        "save" : "Save"
    },
    "fr" : {
        "save": "Enregistrer"
    }
}
</i18n>
